export default __webpack_public_path__ + "static/media/arrow_blue.784d7fbe.svg";